import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft2, ArrowRight2, ShoppingCart } from "iconsax-react";
import { Pagination } from "antd";

const OtherProductsSlider = ({
  products,
  productsPerPage = 3,
  formatRupiah,
  currentProductId,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const filteredProducts = products.filter(
    (item) => item.id !== currentProductId
  );

  const isSliderNeeded = !isMobile && filteredProducts.length > productsPerPage;
  const maxIndex = Math.max(filteredProducts.length - productsPerPage, 0);

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(prev + 1, maxIndex));
  };

  let visibleProducts = [];

  if (isSliderNeeded) {
    visibleProducts = filteredProducts.slice(
      currentIndex,
      currentIndex + productsPerPage
    );
  } else {
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    visibleProducts = filteredProducts.slice(start, end);

    // Spacer jika tidak pakai slider
    // visibleProducts.push({ id: "spacer-empty", spacer: true });
  }

  return (
    <div className="max-w-6xl mx-auto pb-28 min-h-[60vh]">
      <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
        <ShoppingCart size="20" color="#5c4033" />
        Produk Lainnya
      </h2>
      <div className="relative">
        <div
          className={
            isSliderNeeded
              ? "md:flex md:overflow-x-auto md:no-scrollbar md:scroll-smooth"
              : "grid md:grid-cols-3 gap-4"
          }
        >
          {visibleProducts.map((item) =>
            item.spacer ? (
              <div
                key="spacer-empty"
                className="mb-4 md:mb-0 md:mx-2 p-4 w-full md:min-w-[300px]"
                style={{ background: "transparent", pointerEvents: "none" }}
              >
                <div style={{ height: 150 }}></div>
              </div>
            ) : (
              <div
                key={item.id}
                onClick={() => navigate(`/catalog/${item.id}`)}
                className="product-card mb-4 md:mb-0 md:mx-2 border rounded-lg shadow-md flex flex-col w-full md:min-w-[300px] p-4 cursor-pointer"
              >
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="product-image mb-4 mx-auto max-h-40 object-contain"
                />
                <h2 className="text-lg font-semibold mb-2">{item.title}</h2>
                <p className="text-sm flex-grow">
                  {item.description.substring(0, 100)}...
                </p>
                <div className="mt-4 flex justify-between items-center text-sm">
                  <span className="font-bold text-[#5c4033]">
                    {/* {formatRupiah(item.price)} */}
                  </span>
                  <button
                    onClick={() => navigate(`/catalog/${item.id}`)}
                    className="px-4 py-2 bg-[#5c4033] text-white rounded-md hover:bg-[#3a2c1e] transition text-xs"
                  >
                    Detail
                  </button>
                </div>
              </div>
            )
          )}
        </div>

        {isSliderNeeded && (
          <>
            <button
              onClick={handlePrev}
              disabled={currentIndex === 0}
              className="hidden md:block absolute top-1/2 -left-8 transform -translate-y-1/2 bg-[#5c4033] text-white rounded-full p-2 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#3a2c1e] transition"
            >
              <ArrowLeft2 size="20" color="#fff" />
            </button>

            <button
              onClick={handleNext}
              disabled={currentIndex >= maxIndex}
              className="hidden md:block absolute top-1/2 -right-8 transform -translate-y-1/2 bg-[#5c4033] text-white rounded-full p-2 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#3a2c1e] transition"
            >
              <ArrowRight2 size="20" color="#fff" />
            </button>
          </>
        )}
      </div>

      {!isSliderNeeded && (
        <>
          <div className="flex justify-center mt-6">
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={filteredProducts.length}
              showSizeChanger={true}
              pageSizeOptions={["3", "6", "9", "12"]}
              onChange={(page, newPageSize) => {
                setCurrentPage(newPageSize !== pageSize ? 1 : page);
                setPageSize(newPageSize);
              }}
            />
          </div>
          <div className="block md:hidden min-h-[300px]"></div>
        </>
      )}
    </div>
  );
};

export default OtherProductsSlider;
